"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
class ApiRetirement {
    static getRetirementSummary(token) {
        let url = `/retirement/summary?client=${token.client}`;
        return Client_1.default.httpGet(url, token);
    }
    static updateContributions(token, body) {
        let url = `/retirement/update`;
        return Client_1.default.httpPost(url, token, body);
    }
    static getCustomRetirementPlan(token) {
        let url = `/retirement/custom`;
        return Client_1.default.httpGet(url, token);
    }
    static getManageOverview(token, employeeId) {
        let url = `/retirement/manage/overview?employeeId=${employeeId}`;
        return Client_1.default.httpGet(url, token);
    }
    static updateManageEnrollment(token, employeeId, body) {
        let url = `/retirement/manage/updateEnrollment?employeeId=${employeeId}`;
        return Client_1.default.httpPost(url, token, body);
    }
    static updateManageElection(token, employeeId, body) {
        let url = `/retirement/manage/updateElection?employeeId=${employeeId}`;
        return Client_1.default.httpPost(url, token, body);
    }
}
exports.default = ApiRetirement;
